<template>
  <div class="qingwu">
    <div class="admin_main_block">
      <div class="admin_main_block_top">
        <div class="admin_main_block_left">
          <div>
            <el-button icon="el-icon-search" @click="exports()">导出表格</el-button>
          </div>
          <div>
            <el-input v-model="where.goodsname" placeholder="请输入商品名称"></el-input>
          </div>
          <div>
            <el-date-picker format="yyyy-MM-dd HH:mm" v-model="where.times" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
<!--          <div style="width:160px;">
            <el-select v-model="where.F_TI_DINGDZT" placeholder="选择类型">
              <el-option label="全部" value=""></el-option>
              <el-option label="待发货" value="1"></el-option>
              <el-option label="待收货" value="2"></el-option>
              <el-option label="售后" value="3"></el-option>
            </el-select>
          </div>-->
          <div>
            <el-button icon="el-icon-search" @click="get_adv_list()">条件筛选</el-button>
          </div>

          <div style="margin-left:50px;">
            <el-button icon="el-icon-bank-card" @click="change_user_money()">卡密生成</el-button>
          </div>
        </div>


        <div class="admin_main_block_right">
          <div>
            <el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button>
          </div>
        </div>
      </div>
      <div class="admin_table_main">
        <el-table :data="list" @selection-change="handleSelectionChange">
          <el-table-column type="selection"></el-table-column>
          <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
          <el-table-column prop="id" label="#" width="70px"></el-table-column>
          <el-table-column prop="goodsname" label="商品名称"></el-table-column>
          <el-table-column prop="nickname" label="商品图片" >
            <template slot-scope="scope">
              <dl class="table_dl">
                <dt><img :src="scope.row.goodsimg||require('@/assets/logo.png')" width="50px" height="50px"></dt>
              </dl>
            </template>
          </el-table-column>
          <el-table-column prop="shangj" label="商家"></el-table-column>
          <el-table-column prop="hes" label="盒数"></el-table-column>
          <el-table-column prop="tihrq" label="提货日期"></el-table-column>

          <el-table-column prop="tihbm" label="提货编码"></el-table-column>
          <el-table-column prop="kam" label="卡密"></el-table-column>
          <el-table-column prop="erwm" label="二维码" >
            <template slot-scope="scope">
              <dl class="table_dl">
                <dt><img :src="scope.row.erwm||require('@/assets/logo.png')" width="50px" height="50px"></dt>
              </dl>
            </template>
          </el-table-column>


          <!--<el-table-column prop="F_VR_MENDDZ" label="门店地址" width="170px"></el-table-column>-->
          <el-table-column prop="chuangjsj" label="创建时间" width="130px">
            <template slot-scope="scope">
              <div v-if="scope.row.chuangjsj<=0"> -</div>
              <div v-else>{{ scope.row.chuangjsj|formatDate }}</div>
            </template>
          </el-table-column>





          <div slot="append">
            <div class='sum_footer xiaoji' ref='sum_xiaoji'>
              <div class='sum_footer_unit'></div>
              <div class='sum_footer_unit'></div>
              <div class='sum_footer_unit'></div>
              <div class='sum_footer_unit center'>总盒数：{{ zongje }}</div>
              <div class='sum_footer_unit center'>总张数：{{ dingds }}</div>
              <div class='sum_footer_unit'></div>
              <div class='sum_footer_unit'></div>
              <div class='sum_footer_unit'></div>
              <div class='sum_footer_unit'></div>
            </div>
          </div>
        </el-table>
        <div class="admin_table_main_pagination">
          <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total"
                         :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
        </div>
      </div>
    </div>


    <!-- 调整资金弹出框 -->
    <el-dialog title="卡密生成" :visible.sync="changeShow" width="30%">

      <el-form ref="form" label-width="90px">
        <el-form-item label="商品选择" prop="mend" @change="selectChange()">
          <el-select v-model="change_info.goods" placeholder="请选择商品" filterable style="width:200px">
            <el-option label="请选择商品" :value="0"></el-option>
            <el-option v-for="(v,k) in goodslist" :key="k" :label="v.goods_name+'_____'+v.shangjmdmc" :value="v.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-form ref="form" label-width="90px">
        <el-form-item label="盒数：">
          <el-input v-model="change_info.hes" type="number"></el-input>
        </el-form-item>
        <el-form-item label="张数：">
          <el-input v-model="change_info.zhangs" type="number"></el-input>
        </el-form-item>
        <el-form-item label="提货日期：">
          <el-date-picker v-model="change_info.tihrq" placeholder="选择时间"  type="date" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>


      <span slot="footer" class="dialog-footer">
                <el-button @click="changeShow = false">取 消</el-button>
                <el-button type="primary" @click="change_start()">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      selectedDay: '',

      list: [],
      total_data: 0, // 总条数
      page_size: 20,
      current_page: 1,
      select_id: '',
      adv_position_id: 0,
      where: {
        goodsname: '',
        times: [],
      },
      zongje: 0,
      dingds: 0,
      changeShow: false, // 显示调整输入框
      change_info: {
        goods: '',
        hes: '',
        zhangs: '',
        tihrq: ''
      },
      dingd_id: 0,
      goodslist: [
      ]


    };
  },
  watch: {},
  computed: {},
  methods: {
    change_user_money: function () {
      this.changeShow = true;
    },
    change_start: function () {


      if(!this.change_info.goods){
        return this.$message.error("请选择商品");
      }
      if(!this.change_info.hes){
        return this.$message.error("请输入盒数");
      }
      if(!this.change_info.zhangs){
        return this.$message.error("请输入张数");
      }
      if(!this.change_info.tihrq){
        return this.$message.error("请输入提货日期");
      }


      this.$post(this.$api.Kamsc, this.change_info).then(res => {
        if (res.code == 200) {
          this.changeShow = false;
          this.$message.success('提交成功');
          this.get_adv_list();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleSelectionChange: function (e) {
      let ids = [];
      e.forEach(v => {
        ids.push(v.id);
      });
      this.select_id = ids.join(',');
    },
    get_adv_list: function () {
      let where = {};
      where.page = this.current_page;
      where.params = this.where;
      this.$get(this.$api.getKamscList, where).then(res => {
        console.log('商品列表')
        console.log(res.data.goods)
        console.log('商品列表')
        console.log(res.data)
        this.page_size = res.data.info.per_page;
        this.total_data = res.data.info.total;
        this.current_page = res.data.info.current_page;
        this.list = res.data.info.data;
        this.zongje = res.data.zongje;
        this.dingds = res.data.dingds;
        this.goodslist = res.data.goods;
        console.log('商品列表2')
        console.log(this.goodslist)
        console.log('商品列表2')
      })

    },
    exports: function () {
      if (this.where.times[0]) {
        this.where.times[0] = this.where.times[0].toGMTString();
        this.where.times[1] = this.where.times[1].toGMTString();
      }
      window.open(`https://apiapple.jizhikaifa.com/api/excel/orderdaoc?goodsname=${this.where.goodsname}&timeone=${this.where.times[0]}&timetwo=${this.where.times[1]}`, '_self');
    },
    // 删除处理
    del: function (id) {
      if (this.$isEmpty(id)) {
        return this.$message.error('请先选择删除的对象');
      }
      this.$post(this.$api.delKamsc, {id: id}).then(res => {
        if (res.code == 200) {
          this.get_adv_list();
          return this.$message.success("删除成功");
        } else {
          return this.$message.error("删除失败");
        }
      });
    },
    current_change: function (e) {
      this.current_page = e;
      this.get_adv_list();
    },
  },
  created() {
    this.get_adv_list();
  },
  mounted() {
  }
};
</script>
<style lang="scss" scoped>
.table_dl_dd_all {
  height: 50px;
  overflow: hidden;
}

.sum_footer {
  display: flex;
  display: -webkit-flex;
  line-height: 50px;
  color: #606266;
}

.sum_footer_unit {
  flex-grow: 1;
  -webkit-flex-grow: 1;
  text-indent: 10px;
  font-size: 14px;
  font-weight: bold;
}

.sum_footer_unit.center {
  text-align: center;
}

.sum_footer.xiaoji {
  border-bottom: 1px solid #EBEEF5;
}

.admin_main_block_left div {
  float: left;
  margin-right: 2px;
}

.el-range-editor--small .el-range-input {
  font-size: 13px;
  width: 120px;
}

.el-select .el-input{
  width:200px;
}

</style>
